const RDFS = "http://www.w3.org/2000/01/rdf-schema#";
const SKOS = "http://www.w3.org/2004/02/skos/core#";
const IAO_DEFINITION = "http://purl.obolibrary.org/obo/IAO_0000115";

/** The properties a Labels section states by default, so it names only the others. */
export const USUAL_LABEL_PREDICATES: ReadonlySet<string> = new Set([`${RDFS}label`]);
/** The properties a Definitions section states by default. */
export const USUAL_DEFINITION_PREDICATES: ReadonlySet<string> = new Set([IAO_DEFINITION, `${SKOS}definition`]);

/** Keys under `ontologyViewer.predicates` for annotation properties with a common meaning. */
export const PREDICATE_NAME_KEYS: Readonly<Record<string, string>> = {
  [`${RDFS}label`]: "label",
  [`${RDFS}comment`]: "comment",
  [`${SKOS}prefLabel`]: "prefLabel",
  [`${SKOS}altLabel`]: "altLabel",
  [`${SKOS}hiddenLabel`]: "hiddenLabel",
  [`${SKOS}definition`]: "definition",
  [`${SKOS}scopeNote`]: "scopeNote",
  [`${SKOS}editorialNote`]: "editorialNote",
  [IAO_DEFINITION]: "definition",
};

/**
 * The text with each paragraph's lines joined: ontology sources wrap long texts at a fixed
 * width, which reads ragged in a narrower or wider column. Blank lines stay paragraph breaks.
 */
export function reflowText(text: string): string {
  return text
    .trim()
    .split(/\n\s*\n/u)
    .map((paragraph) => paragraph.split(/\s*\n\s*/u).join(" "))
    .join("\n\n");
}
